import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, memo } from "react";
import { mergeSx } from "../system";
import { BaseComponent } from "./BaseComponent";
export const boxClasses = {
    root: "MinervaBox-root",
};
/**
 * The Box component is a low level mirror of a div. This component is commonly
 * used as a catch all container for dom nodes that do not need to implement specific
 * boiler plate functionality. It extends the BaseComponent to provide a default html
 * tag of div and also exposes the sx prop.
 *
 * @example `<Box sx={{ color: "red" }} />`
 *
 * @returns JSX.Element (jsx import modified to be EmotionJSX.Element)
 */
export const Box = memo(forwardRef(({ height, width, className, sx, ...props }, ref) => {
    return (_jsx(BaseComponent, { ref: ref, as: "div", className: clsx([className, boxClasses.root]), sx: mergeSx({
            boxSizing: "inherit",
            height,
            width,
        }, sx), ...props }));
}));
//# sourceMappingURL=Box.js.map